`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('buddhist-dictionary.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'buddhist-dictionary-tool' }">{{ $t('buddhist-dictionary.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>佛學辭典集成</h3>
        <p>
          軟體名稱：佛學辭典集成(繁體版)<br>
          檔案名稱：<a href="https://www2.budaedu.org/official-website-data/buddhist-dictionary-tool/FO-DICT.zip" target="_blank">FO-DICT.zip</a><br>
          檔案大小：39.764 MB<br>
          版　　本：v3.2.22
        </p>
        <p>
          【使用說明】<br>
          1. 本軟體為綠色軟體，使用時不須安裝。<br>
          2. 解壓縮 FO-DICT.zip 檔案完成後，請進入資料夾 FO-DICT 中，雙擊FoDict.exe即可。<br>
          3. 本軟體共包含二十八本辭典，開啟軟體並輸入關鍵字後，會搜尋全部辭典。<br>
&nbsp;&nbsp;&nbsp;
  A Buddhist Glossary<br>
　Buddhism Glossary<br>
　Glossary of Pali and Buddhist Terms<br>
　Glossary of Terms<br>
　《三藏法數》　　　　（明　一如等集註）<br>
　《中國大百科全書(摘錄)》<br>
　《中國五百羅漢》<br>
　《中國佛教》　　　　（趙樸初）<br>
　《中華佛教百科全書》<br>
　《五燈會元》　　　　（宋　普濟禪師）<br>
　《巴英南傳佛教辭典》（Nyanaponika 編）<br>
　《巴漢英釋佛學辭彙》<br>
　《佛光大辭典》　　　（慈怡　主編）<br>
　《佛教的手印》<br>
　《佛教的法器》　　（李樹琦編著）<br>
　《佛教常用唄器器物服裝簡述》　　（祥雲法師）<br>
　《佛學大辭典》　　　（丁福保　編著）<br>
　《佛學次第統編》　　（明　楊卓　編著）<br>
　《佛學常見辭彙》　　（陳義孝　編著）<br>
　《法門名義集》　　　（唐　李師政撰）<br>
　《法界次第初門》　　（隋　智者大師撰）<br>
　《法相辭典》　　　　（朱芾煌編）<br>
　《法苑談叢》　　　　（周叔迦）<br>
　《俗語佛源》　　　　（中國佛教文化研究所編）<br>
　《漢英佛學辭典》　　　　（William Edward Soothill & Lewis Hodous）<br>
　《漢英-英漢-英英佛教詞彙》（以Charles Muller的DEABT辭典和“The Seeker's Glossary of Buddhism”為主，加上其它詞彙編輯而成）<br>
　《禪宗典籍550種提要》（吳言生）<br>
　《翻譯名義集》　　　（宋　普潤大師法雲編）
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>實用佛學辭典</h3>
        <p>
          書籍名稱：實用佛學辭典<br>
          檔案名稱：<a href="https://www2.budaedu.org/official-website-data/buddhist-dictionary-tool/CH030-07.pdf" target="_blank">CH030-07.pdf</a><br>
          檔案大小：117 MB<br>
          檔案格式：PDF 電子檔
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>教乘法數</h3>
        <p>
          軟體名稱：教乘法數 (PDF 格式)<br>
          檔案名稱：<a href="https://www2.budaedu.org/official-website-data/buddhist-dictionary-tool/JCfashu.pdf" target="_blank">JCfashu.pdf</a><br>
          檔案大小：10 MB
        </p>
        <p>
          軟體名稱：教乘法數 (ZIP 格式)<br>
          檔案名稱：<a href="https://www2.budaedu.org/official-website-data/buddhist-dictionary-tool/JCfashu.zip" target="_blank">JCfashu.zip</a><br>
          檔案大小：181 MB<br>
          版　　本： Accelon 3.60 121
        </p>
        <p>
          【使用說明】<br>
          ◎本軟體為綠色軟體，使用時不須安裝。<br>
          ◎解壓縮 JCfashu.zip 檔案完成後，請進入資料夾 JCfashu 中，雙擊 accelon3.exe 即可。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)
Vue.use(TabsPlugin)

export default {
  i18n,
  name: 'buddhist-dictionary-tool',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('buddhist-dictionary.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>